import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CoursesComponent } from './components/courses/courses.component';
import { HomeComponent } from './components/home/home.component';
import { InPersonServicesComponent } from './components/in-person-services/in-person-services.component';
import { OnlineServicesComponent } from './components/online-services/online-services.component';


const routes: Routes = [
    { path: '', component: HomeComponent },
    { path: 'online', component: OnlineServicesComponent },
    { path: 'presencial', component: InPersonServicesComponent },
    { path: 'cursos', component: CoursesComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
